import { Component } from '@angular/core';
import { NotificationWebSocketService } from './core/services/notification-websocket.service';

@Component({
  selector: 'app-root',
  template: `
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  `,
  styles: [`
    :host {
      display: block;
      min-height: 100vh;
    }

    router-outlet + * {
      display: block;
      min-height: calc(100vh - 72px);
    }
  `],
})
export class AppComponent {
  constructor(notificationWebSocket: NotificationWebSocketService) {}
}
